import React from 'react';
import styled from 'styled-components';
import { apiClient } from '../../utils/axios-client';
import { openGameWindow } from '../../utils/open-game-window';

const mobile = '(min-width: 1px) and (max-width: 576px)';

const ThumbnailDiv = styled.div`
    position: relative;
    width: 350px;
    height: 180px;
    display: flex;
    flex-direction: row;
    align-items: center;
    caret-color: transparent;
    margin: 20px 40px 20px 40px;

    @media ${mobile} {
        height: 150px;
    }
`;

const SkillBingoImage = styled.img`
    width: 100%;
    height: 179px;
    image-rendering: -webkit-optimize-contrast;

    &:hover {
        cursor: pointer;
    }

    @media ${mobile} {
        transform: scale(0.8);
    }
`;

const SkillBingoThumbnail = (props) => {
    const { sessionId, parlaySite, gameId, lang, thumbnail } = props;

    const onLaunch = (launchFree) => async () => {
        const gameWindow = openGameWindow();

        const gameLaunchData = await apiClient.post('/launchcasinogame', {
            gameId,
            parlaySite,
            free: launchFree,
            lang,
        });

        if (gameLaunchData.data.error) {
            const { error } = gameLaunchData.data;
            console.error(error);
            gameWindow.close();
            return;
        }

        const { launchUrl } = gameLaunchData.data;

        gameWindow.location = launchUrl;
    };

    return (
        <ThumbnailDiv>
            <SkillBingoImage src={thumbnail} onClick={onLaunch(false)} />
        </ThumbnailDiv>
    );
};

export default React.memo(SkillBingoThumbnail);
